<template>
  <div class="Mobiles">
    <Mobileheader name="产品与方案" routeNmae="/solutioNav" v-if="$store.state.isMobile !== 3" />
    <div class="headerTabs">
      <el-tabs class="tabs" stretch v-model="tabIndex" @tab-click="handleClick">
        <template v-for="(item, index) in list">
          <el-tab-pane :label="item" :name="index + ''">
            <el-collapse accordion>
              <template v-for="item in listData[tabIndex].childrenList">
                <el-collapse-item class="heightcollapse">
                  <template slot="title">
                    <div class="title">
                      <img src="@/assets/static/gscp.png" alt=""> <span>{{ item.name }} </span>
                    </div>
                  </template>
                  <div class="content">

                    <template v-for="obj in item.childrenList">
                      <div class="childLabel" @click="openPdf(obj.reqUrl, '', index, obj,)">

                        <span>{{ obj.name }}</span>
                        <template v-if="obj.childrenList">
                          <div class="displey" v-for="o in obj.childrenList" @click="openPdf(o.reqUrl, '', index, o,)">
                            <span>{{ o.name }}</span>

                          </div>
                        </template>

                      </div>
                    </template>

                  </div>
                </el-collapse-item>
              </template>

            </el-collapse>

          </el-tab-pane>
        </template>
      </el-tabs>
    </div>

    <template>

      <div class="tabCont">

      </div>

    </template>

  </div>
</template>

<script>
// import {
// 	getProductProgrammeList
// } from "@/api/web.js"
import { getProductProgrammeList } from "@/api/solutio";
export default {
  data () {
    return {
      showImg: false,
      tabIndex: '0',
      listData: [],
      list: [],
      contList: [],
      value: "",
      show: true

    };
  },
  mounted () {
    getProductProgrammeList({ isRelease: this.$store.state.editStatus }).then(res => {
      this.listData = res.data;
      this.list = [];
      res.data.forEach(e => {
        this.list.push(e.name)
      })
    })
  },
  methods: {
    collapseChange () {

    },
    handleClick (e) {
      this.tabIndex = e.index;
    },
    openPdf (pdf = "", url = "", type = "", obj,) {
      if (obj.urlType == 4) {
        this.$router.push({
          path: '/pageTemplatePhone',
          query: {
            data: JSON.stringify(
              obj
            ),
          }
        })
        return
      }


      let d = new Date()
      if (obj.reqUrl.indexOf('.pdf') > -1) {
        this.$router.push({ path: '/productPdfPhone', query: { name: pdf, url: url, type: type, productName: obj.name, parentId: obj.parentId, objId: obj.id, t: d.getTime() } });
      } else {
        window.open(obj.reqUrl)
      }



    },
    clickTab (e) {
      this.tabIndex = e.index
      this.show = false;
      setTimeout(() => {
        this.show = true;
      }, 100)
    },
    showImage (data) {
      let urls = [];
      data.forEach(e => {
        urls.push(e.img)
      })
      uni.predivImage({
        urls: urls,
        current: data.img
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.headerTabs {
  position: fixed;
  top: 90px;
  width: 100%;
  height: 80px;
  background-color: #fff;
  z-index: 999;
  ::v-deep .el-tabs__content {
    height: calc(100vh - 220px) !important;
    overflow: scroll;
  }
}

.tabCont {
  padding-top: 80px;
}

::v-deep .u-tabs__wrapper__nav__item__text {
  font-size: 28px !important;
}

.tabsLine {
  border-bottom: 1px solid #ddd;
  margin-top: -6px;
}

.content {
  padding: 30px;

  .childLabel {
    width: 636px;
    min-height: 50px;
    background: rgba(58, 136, 255, 0.6);
    border-radius: 6px;
    margin-bottom: 18px;
    line-height: 50px;
    padding: 0 20px;
    box-sizing: border-box;
    color: #fff;
    text-align: left;
    font-size: 28px;

    &:last-child {
      margin-bottom: 0;
    }

    .displey {
      display: flex;
      align-items: center;
      padding-left: 50px;
      border-top: 1px solid #fff;
    }
  }

  ::v-deep .uni-collapse-item {
    // padding-bottom: 20px;
    .uni-collapse-item-border {
      border: none;
      align-items: flex-start;
    }
  }

  ::v-deep .uni-collapse-item__title-box {
    height: 50px;
    line-height: 50px;
    background: rgba(58, 136, 255, 0.6);
    border-radius: 6px;
    margin-bottom: 18px;
    color: #fff;
  }
}

.heightcollapse {
  //   height: 100vh;
}
</style>